import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import client_lookups from '@/assets/json/clientLookups.json'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const checkFatherIdentityInfo = async () => {
  const formStore = useFormStore()
  const { fatherUnifiedNumber, fatherIdentityNumber } = formStore.form.values
  try {
    const result = await apiHelperService.get(`/api/Breadwinning/draft/checkPersonInfo`, {
      params: {
        unifiedNumber: fatherUnifiedNumber,
        identityNumber: fatherIdentityNumber
      }
    })

    const { unifiedNumber, identityNumber } = result

    if (!result?.hasPersonProfile) {
      formStore.form.setValues({
        fatherUnifiedNumber: '',
        fatherIdentityNumber: ''
      })
      doNotify(i18n.global.t('ERRORS'), i18n.global.t('invalidFatherInfo'), undefined, 'error')
      return
    }

    formStore.form.setValues({
      fatherUnifiedNumber: unifiedNumber,
      fatherIdentityNumber: identityNumber
    })
  } catch (error) {
    formStore.form.setValues({
      fatherUnifiedNumber: '',
      fatherIdentityNumber: ''
    })
    doNotify(i18n.global.t('ERRORS'), i18n.global.t('invalidFatherInfo'), undefined, 'error')
    console.error(error)
  }
}

const checkChildIdentityInfo = async () => {
  const formStore = useFormStore()
  try {
    const { unifiedNumber: editUnifiedNumber, eId } = formStore.form.values.edit_childrensInfoList
    const result = await apiHelperService.get(`/api/Breadwinning/draft/checkPersonInfo`, {
      params: {
        unifiedNumber: editUnifiedNumber,
        identityNumber: eId
      }
    })

    const { unifiedNumber, identityNumber } = result

    formStore.form.setFieldValue('edit_childrensInfoList.eId', identityNumber)
    formStore.form.setFieldValue('edit_childrensInfoList.unifiedNumber', unifiedNumber)

    if (!result?.hasPersonProfile) {
      formStore.form.setFieldValue('edit_childrensInfoList.eId', '')
      formStore.form.setFieldValue('edit_childrensInfoList.unifiedNumber', '')
      doNotify(i18n.global.t('ERRORS'), i18n.global.t('invalidChildInfo'), undefined, 'error')
      return
    }

    formStore.form.setFieldValue('edit_childrensInfoList.eId', identityNumber)
    formStore.form.setFieldValue('edit_childrensInfoList.unifiedNumber', unifiedNumber)
  } catch (error) {
    formStore.form.setFieldValue('edit_childrensInfoList.eId', '')
    formStore.form.setFieldValue('edit_childrensInfoList.unifiedNumber', '')
    doNotify(i18n.global.t('ERRORS'), i18n.global.t('invalidChildInfo'), undefined, 'error')
    console.error(error)
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkFatherIdentityInfo':
      return checkFatherIdentityInfo(actionParams)
    case 'checkChildIdentityInfo':
      return checkChildIdentityInfo(actionParams)
    default:
      break
  }
}
